import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/researchmanager.webp';
import screenshot_target from '../../../images/letterfunnel/paulsomberg.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Paul Somberg"
      firstname="Paul"
      companyname="ResearchManager"
      competition="Castor en Viedoc"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/paulsomberg.js